import * as React from "react";
type Props = {
  className?: string,
};
function SvgServings({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-servings"
      className={className}
    >
      <path
        d="M2.51 16.2H21.51C21.5731 16.1959 21.6363 16.2044 21.6961 16.2248C21.7559 16.2452 21.8111 16.2773 21.8585 16.3191C21.9058 16.3609 21.9445 16.4116 21.9722 16.4684C21.9999 16.5252 22.0162 16.5869 22.02 16.65V18.55C22.0162 18.6131 21.9999 18.6748 21.9722 18.7316C21.9445 18.7884 21.9058 18.8391 21.8585 18.8809C21.8111 18.9227 21.7559 18.9548 21.6961 18.9752C21.6363 18.9956 21.5731 19.0041 21.51 19H2.51C2.44694 19.0041 2.3837 18.9956 2.3239 18.9752C2.2641 18.9548 2.20893 18.9227 2.16154 18.8809C2.11416 18.8391 2.0755 18.7884 2.04778 18.7316C2.02005 18.6748 2.00382 18.6131 2 18.55V16.65C2.00382 16.5869 2.02005 16.5252 2.04778 16.4684C2.0755 16.4116 2.11416 16.3609 2.16154 16.3191C2.20893 16.2773 2.2641 16.2452 2.3239 16.2248C2.3837 16.2044 2.44694 16.1959 2.51 16.2V16.2ZM19.75 16.2C19.8424 15.7796 19.8894 15.3505 19.89 14.92C19.89 11.09 16.36 8 12 8C7.64 8 4.11 11.12 4.11 15C4.11062 15.4305 4.15755 15.8596 4.25 16.28L19.75 16.2Z"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M12 3.99999C11.7068 3.99336 11.4152 4.04489 11.142 4.15161C10.8688 4.25832 10.6195 4.41811 10.4084 4.62174C10.1974 4.82537 10.0287 5.0688 9.91228 5.33798C9.79583 5.60715 9.73388 5.89673 9.72999 6.18999C9.72492 6.79344 9.91426 7.3825 10.27 7.86999L10.63 8.26999L11.16 8.19999L11.05 7.19999L11.17 8.19999H11.23H11.59C11.8529 8.17999 12.117 8.17999 12.38 8.19999H12.76L13.32 8.30999L13.7 7.87999C14.0557 7.3925 14.2451 6.80344 14.24 6.19999C14.2374 5.90845 14.1774 5.62028 14.0634 5.35194C13.9494 5.0836 13.7837 4.84033 13.5756 4.63604C13.3676 4.43175 13.1214 4.27043 12.8511 4.1613C12.5807 4.05216 12.2915 3.99735 12 3.99999Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgServings;
